<template>
  <v-layout
    row
    wrap
    mt-3
  >
    <p class="fw-600 f-1 mb-0 mt-3 required-block">
      4. {{ $t('warehouses.locationData.directions') }}
    </p>
    <p class="font-weight-regular f-16">
      {{ $t('warehouses.locationData.road_directions_hint') }}
    </p>
    <v-flex xs12>
      <v-textarea
        v-model="directions"
        v-validate="validationRule"
        :error-messages="errors.collect('directions')"
        :data-vv-as="' '"
        :data-vv-name="'directions'"
        :required="warehouseType === 1"
        auto-grow
        :disabled="readOnly"
        @blur="emitDirections()"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from '@/constants/validationRules';

import { mapFields } from 'vuex-map-fields';

export default {
    name: 'RoadDirections',
    inject: ['$validator'],
    props: {
        warehouseType: {
            required: true,
            type: Number
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRule: validationRules.get('warehouseDirections')
        };
    },
    computed: {
        ...mapFields('warehouses', ['directions'])
    },
    methods: {
        emitDirections () {
            this.$emit('emitDirections', this.directions);
        }
    }
};
</script>

<style scoped></style>
